export default __webpack_public_path__ + "static/media/owncast.d6e37b83.svg";